import React from 'react';

export default class Paginate extends React.Component {
	render() {
		const direction = this.props.up ? 'up' : 'down';
		return(
			<div 
				className={direction + ' paginate'}
				onClick={() => this.props.handlePaginate(direction)}
			>
				<svg width="100%" height="100%" viewBox="0 0 38 31" fill="none"><path d="M18.7212 7.66049L19.1935 7.63437V7.16125V1.04498L37.2008 15.5541L19.1476 29.9613V23.702V23.202H18.6476H0.5V7.75754C0.607816 7.75666 0.731967 7.75574 0.871176 7.75478C1.39196 7.75117 2.12169 7.74703 2.99112 7.74251C4.7299 7.73348 7.02629 7.723 9.32492 7.71251L9.67281 7.71093C14.1375 7.69056 18.5404 7.67049 18.7212 7.66049Z"></path></svg>
			</div>
		);
	}
}